// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/element/pricing/pricing.scss
 ** module id = 102
 ** module chunks = 0 1
 **/